import Card from './card';
import './styles/index.scss';
export default Card;
